// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3msPn","col":"styles_col__1-KHe"};